import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { affApi } from "../../lib/affApi";
import { fmtErr } from "../../lib/api";

const Field = ({ id, label, value, onChange, type = "text", testId, placeholder }) => (
  <div><Label htmlFor={id}>{label}</Label><Input id={id} type={type} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} /></div>
);

export function SettingsTab({ affiliate, onSaved }) {
  const [profile, setProfile] = useState({ name: affiliate.name || "", company: affiliate.company || "" });
  const [payout, setPayout] = useState({ holder: "", bank_name: "", iban: "", bic: "", paypal_email: "", ...(affiliate.payout || {}) });
  const [pwd, setPwd] = useState({ current_password: "", new_password: "" });
  const setP = (k) => (v) => setPayout((p) => ({ ...p, [k]: v }));

  const saveProfile = async (e) => {
    e.preventDefault();
    try { const { data } = await affApi.patch("/affiliate/me", profile); toast.success("Profile saved"); onSaved(data); } catch (e2) { toast.error(fmtErr(e2)); }
  };
  const savePayout = async (e) => {
    e.preventDefault();
    try { const { data } = await affApi.patch("/affiliate/me", { payout }); toast.success("Payout details saved"); onSaved(data); } catch (e2) { toast.error(fmtErr(e2)); }
  };
  const savePwd = async (e) => {
    e.preventDefault();
    try { await affApi.post("/affiliate/change-password", pwd); toast.success("Password changed"); setPwd({ current_password: "", new_password: "" }); } catch (e2) { toast.error(fmtErr(e2)); }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="aff-settings">
      <form onSubmit={saveProfile} className="rounded-xl border border-zinc-200 bg-white p-5 space-y-3" data-testid="aff-settings-profile">
        <div className="font-medium">Profile</div>
        <Field id="s-name" label="Full name" value={profile.name} onChange={(v) => setProfile((p) => ({ ...p, name: v }))} testId="aff-settings-name" />
        <Field id="s-company" label="Company" value={profile.company} onChange={(v) => setProfile((p) => ({ ...p, company: v }))} testId="aff-settings-company" />
        <div className="text-xs text-zinc-500">Email: {affiliate.email} · Code: <span className="font-mono">{affiliate.code}</span></div>
        <Button type="submit" className="bg-ink hover:bg-black" data-testid="aff-settings-profile-save">Save profile</Button>
      </form>

      <form onSubmit={savePayout} className="rounded-xl border border-zinc-200 bg-white p-5 space-y-3" data-testid="aff-settings-payout">
        <div className="font-medium">Payout details</div>
        <p className="text-xs text-zinc-500">Bank transfer (IBAN/BIC) or PayPal. Fill in one of the two.</p>
        <Field id="p-holder" label="Account holder" value={payout.holder} onChange={setP("holder")} testId="aff-payout-holder" />
        <Field id="p-bank" label="Bank name" value={payout.bank_name} onChange={setP("bank_name")} testId="aff-payout-bank" />
        <div className="grid grid-cols-1 sm:grid-cols-[1fr_140px] gap-3">
          <Field id="p-iban" label="IBAN" value={payout.iban} onChange={setP("iban")} testId="aff-payout-iban" />
          <Field id="p-bic" label="BIC / SWIFT" value={payout.bic} onChange={setP("bic")} testId="aff-payout-bic" />
        </div>
        <Field id="p-paypal" label="PayPal email" type="email" value={payout.paypal_email} onChange={setP("paypal_email")} testId="aff-payout-paypal" />
        <Button type="submit" className="bg-ink hover:bg-black" data-testid="aff-payout-save">Save payout details</Button>
      </form>

      <form onSubmit={savePwd} className="rounded-xl border border-zinc-200 bg-white p-5 space-y-3" data-testid="aff-settings-password">
        <div className="font-medium">Change password</div>
        <Field id="c-cur" label="Current password" type="password" value={pwd.current_password} onChange={(v) => setPwd((p) => ({ ...p, current_password: v }))} testId="aff-pwd-current" />
        <Field id="c-new" label="New password (min. 8 characters)" type="password" value={pwd.new_password} onChange={(v) => setPwd((p) => ({ ...p, new_password: v }))} testId="aff-pwd-new" />
        <Button type="submit" variant="outline" data-testid="aff-pwd-save">Change password</Button>
      </form>
    </div>
  );
}
